// helper method that sets the downpayment value to whatever comes from the DR settings API, null, or undefined.
const getDownPaymentAmount = (settings, dealType, vehicleType) => {
  if (dealType === 'leasing') vehicleType = '';
  const dealSettings = settings[dealType];
  const fixedAmountKey = `downPaymentFixedAmount${vehicleType}`;
  if (dealSettings?.isDownPaymentFixedAmount) {
    return dealSettings[fixedAmountKey];
  }
  return null;
};

// helper method that sets the downpayment percentage value to whatever comes from the DR settings API, null, or undefined.
const getDownPaymentPercentage = (settings, dealType, vehicleType) => {
  if (dealType === 'leasing' || dealType === 'financing' && vehicleType === 'New') {
    vehicleType = '';
  }
  const dealSettings = settings[dealType];
  if (dealSettings?.isDownPaymentFixedAmount) {
    return null;
  }
  const downPaymentPercent = dealSettings[`downPaymentPercent${vehicleType}`];
  return downPaymentPercent ? downPaymentPercent / 100 : 0.1; // Default to 10%
};

// checks the existing config, then returns a value from DR settings if undefined and null if null
// we do not want to overwrite null values as it's assumed they were set to null intentionally
const getDownPaymentValue = (value, settings, type, category) => {
  if (value === null) {
    return null;
  }
  return value !== undefined ? value : getDownPaymentAmount(settings, category, type);
};

// checks the existing config, then returns a value from DR settings if undefined and null if null
// we do not want to overwrite null values as it's assumed they were set to null intentionally
const getPercentageValue = (value, settings, type, category) => {
  if (value === null) {
    return null;
  }
  return value !== undefined ? value : getDownPaymentPercentage(settings, category, type);
};
export { getDownPaymentValue, getPercentageValue };
